import AssetLogo from "./asset-logo";

export default function PlayerLogo({ playerId, size = 40, className = '' }: { playerId: number, size?: number, className?: string }) {
    return (
        <AssetLogo
            id={playerId}
            folder="players"
            alt="player image"
            size={size}
            className={className}
        />
    );
}
